module.exports = __webpack_public_path__ + "img/6.0438c38c.png";